<template>
  <div class="row small-gutters mb-4" v-if="isLoaded">
    <div v-if="$currentUser" class="col" :class="{ 'col-6': $currentUser, 'col-12': !$currentUser }">
      <bookmark-folder
        class="mb-2"
        :currentItem="item"
        :scope="scope"
        isButton
        isFullButton
      />
    </div>
    <div class="col" :class="{ 'col-6': $currentUser, 'col-12': !$currentUser }">
      <send-email
        :item="item"
        :scope="scope"
        :contacts="contacts"
      />
    </div>
    <div v-if="isLoaded && $currentUser" class="col" :class="{ 'col-6': $currentUser, 'col-12': !$currentUser }">
      <create-alert
        :item="item"
        :scope="scope"
        isSecondary
      />
    </div>
    <div class="col" :class="{ 'col-6': $currentUser, 'col-12': !$currentUser }">
      <share
        :item="item"
        :scope="scope"
      />
    </div>
  </div>
</template>

<script>
import CreateAlert from '@/components/shared/profile/CreateAlert'
import SendEmail from '@/components/shared/profile/SendEmail'
import Share from '@/components/shared/profile/Share'
import BookmarkFolder from '@/components/bookmark_folder/Show'

export default {
  name: 'profileActions',
  components: {
    CreateAlert,
    SendEmail,
    BookmarkFolder,
    Share
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    scope: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    contacts: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {

  }
}
</script>
